module.exports = __webpack_public_path__ + "static/media/User_Icon_4.038f3d83.svg";